import type { ReactNode } from 'react';
import { COPY } from '../content';
import type { Overview } from '../api';
import { getCreds } from '../session';

/** A small environment badge from the API URL (Local for localhost / 127.0.0.1, else Remote). */
function envLabel(baseUrl: string): string {
  return /localhost|127\.0\.0\.1/.test(baseUrl) ? 'Local' : 'Remote';
}

const TABS: { key: string; label: string; badge?: (o: Overview) => number }[] = [
  { key: 'overview', label: COPY.nav.overview },
  { key: 'applications', label: COPY.nav.applications, badge: (o) => o.applicationsInReview },
  { key: 'members', label: COPY.nav.members },
  { key: 'money', label: COPY.nav.money, badge: (o) => o.couponReview },
  { key: 'payouts', label: COPY.nav.payouts },
  { key: 'moderation', label: COPY.nav.moderation, badge: (o) => o.moderationOpen },
  { key: 'reports', label: COPY.nav.reports },
  { key: 'game', label: COPY.nav.game },
];

export function Shell({
  active,
  overview,
  onSignOut,
  children,
}: {
  active: string;
  overview: Overview | null;
  onSignOut: () => void;
  children: ReactNode;
}) {
  const creds = getCreds();
  return (
    <div className="app">
      <header className="topbar">
        <span className="brand">Hydrus admin</span>
        {creds ? <span className="env-badge">{envLabel(creds.baseUrl)}</span> : null}
        <span className="spacer" />
        <button className="ghost" style={{ color: '#fff' }} onClick={onSignOut}>
          {COPY.common.signOut}
        </button>
      </header>
      <nav className="nav">
        {TABS.map((t) => {
          const count = overview && t.badge ? t.badge(overview) : 0;
          return (
            <a key={t.key} href={`#/${t.key}`} className={active === t.key ? 'active' : ''}>
              {t.label}
              {count > 0 ? <span className="count">{count}</span> : null}
            </a>
          );
        })}
      </nav>
      <main className="main">{children}</main>
    </div>
  );
}
